export default __webpack_public_path__ + "static/media/Table.5b2b8462.png";